import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["referenceableType"]

  connect() {
    // Initialize the controller
  }

  updateReferenceableType(event) {
    const selectedType = event.target.value
    const referenceableTypeSelect = this.element.closest('form').querySelector('select[name="service_request_master[referenceable_type]"]')
    
    if (referenceableTypeSelect) {
      // Update available reference types based on service request type
      // This is a placeholder - you'll need to implement the actual logic
      // based on your business rules
      const options = {
        'sales': ['SalesOrder'],
        'lease': ['LeaseOrder']
      }
      
      const availableTypes = options[selectedType] || []
      
      // Clear and update options
      referenceableTypeSelect.innerHTML = '<option value="">Select reference type</option>'
      availableTypes.forEach(type => {
        const option = new Option(type, type)
        referenceableTypeSelect.add(option)
      })
    }
  }
} 